module.exports = __webpack_public_path__ + "img/9788970638362.2e6d744e.jpg";